export default {
  forgot_password_confirm: {
    title: 'Réinitialiser le mot de passe',
    required_code: 'Le code est requis',
    required_password: 'Le mot de passe est requis',
    max_length_16: 'Le mot de passe doit comporter 8 à 16 caractères',
    // no_blank: "",
    no_password_match: 'Le mot de passe ne correspond pas',
    reset_password: 'Réinitialiser le mot de passe',
    caution: 'Ne fermez pas cette fenêtre',
    double_check_text: '@:login.double_check_text',
    password_reset_text: "Un e-mail a été envoyé à l'adresse e-mail. Veuillez saisir le code de vérification envoyé à votre adresse e-mail ci-dessous.",
    verification_code: 'Code de vérification',
    mail_send_code: "Code envoyé dans l'e-mail",
    password: 'Mot de passe',
    new_password: 'Nouveau mot de passe',
    password_display: 'Afficher le mot de passe',
    password_no_display: 'Cacher le mot de passe',
    password_check: 'Nouveau mot de passe (confirmer)',
    submit: 'Confirmer',
  },
}
